import React, { useEffect, useMemo } from 'react';
import CustomSelect from '../../components/CustomSelect';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { TReviewType } from '../../types';
import { reviewsTypePlaceholder } from '../../constants/placeholder';
import { commonBackInfo } from '../../utils';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import { useIntl } from 'umi';
import { getReviewTypesOptions } from '../../constants/reviewTypes';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
import { useOptionsMemo } from '../../hooks/common';

export default function ReviewsTypeSelect({
  onChange,
  defaultValue,
  defaultKey,
  filterValue,
  lang,
  filterOptions,
  dealwithOptions,
  hasAllSelected,
}: TReviewType) {
  const { formatOptionsMessage } = useLanguage();

  const options = useOptionsMemo({
    options: formatOptionsMessage(getReviewTypesOptions(filterOptions)),
    dealwithOptions,
    key: 'review_types',
    deeps: [formatOptionsMessage],
  });

  const {
    selects: reviewTypesSelects,
    setSelects: setReviewTypesSelects,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    defaultKey: 'review_types',
    options: options.map((item) => item.value),
  });

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();
  const { formatMessage } = useIntl();
  useEffect(() => {
    const [text, isAll] = getButtonElement();
    onChange?.(
      'review_types',
      commonBackInfo(
        { review_types: reviewTypesSelects },
        { [defaultKey]: text },
        { needChangeEntity: true, isAll },
      ),
    );
  }, [reviewTypesSelects, formatMessage]);

  return (
    <div className={diffClassName}>
      <CustomSelect
        ref={customSelectRef}
        matchButtonWidth={false}
        placeholderText={reviewsTypePlaceholder[lang]}
        onClear={() => setReviewTypesSelects([])}
        selectOptionsInfo={[reviewTypesSelects, setReviewTypesSelects]}
        options={options}
        pointKey={FilterButtonPoint.reviewType}
        hasAllSelected={hasAllSelected}
      ></CustomSelect>
    </div>
  );
}
